// ------------------------------------
// Constants/Types
// ------------------------------------

export const UPDATE_PLATFORMS = 'src/platforms/UPDATE_PLATFORMS';
